import React, {
    FC, useCallback, useEffect, useState
} from 'react'
import { Button, Form } from 'react-bootstrap'
import styled from 'styled-components'

import { _, colors } from 'utils'
import { Formik, FormikProps } from 'formik'
import Editor from 'features/forms/components/Editor'
import { EditorMode } from '../types'

const S = {
    Container: styled.div`
        position: relative;
        padding: 10px;
        margin: 0 -10px;
        transition: background-color 250ms ease-in-out;
        min-height: 330px;

        &:hover {
            background-color: rgba(45, 48, 53, 0.03);
            cursor: pointer;
        }
    `,
}

export interface EditableEditorFieldProps {
    defaultValue: string
    label: string
    onUpdate(value: string): void
}

const EditableEditorField: FC<EditableEditorFieldProps> = ({
    defaultValue,
    label,
    onUpdate,
}: EditableEditorFieldProps) => {
    const [value, setValue] = useState(defaultValue)
    const [editMode, setEditMode] = useState(EditorMode.preview)

    const editorClickHandler = useCallback(() => {
        setEditMode(EditorMode.write)
    }, [setEditMode])

    const buttonUpdateClickHandler = useCallback((_value) => {
        if (onUpdate) {
            setValue(_value)
            onUpdate(_value)
        }
        setEditMode(EditorMode.preview)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const buttonCancelClickHandler = useCallback(() => {
        setValue(defaultValue)
        setEditMode(EditorMode.preview)
    }, [defaultValue, setValue, setEditMode])

    useEffect(() => {
        setValue(defaultValue)
    }, [defaultValue])

    return (
        <Form.Group>
            <Form.Label>{label}</Form.Label>
            {editMode === EditorMode.preview ? (
                <S.Container onClick={editorClickHandler}>
                    <div
                        dangerouslySetInnerHTML={{ __html: value }}
                        style={{fontSize: 14, color: colors.grayDescription}}
                    />
                </S.Container>
            ) : (
                <>
                    <Formik
                        initialValues={{ value }}
                        onSubmit={({value: _value}) => buttonUpdateClickHandler(_value)}
                    >
                        {({handleSubmit}: FormikProps<{value?: string}>) => (
                            <Form>
                                <Editor name="value" label="" className="mb-0" />
                                <Button
                                    variant="primary mr-2"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        handleSubmit()
                                    }}
                                >
                                    {_('form.save')}
                                </Button>
                                <Button
                                    variant="default"
                                    onClick={buttonCancelClickHandler}
                                >
                                    {_('form.cancel')}
                                </Button>
                            </Form>
                        )}
                    </Formik>
                </>
            )}
        </Form.Group>
    )
}

export default EditableEditorField
